import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="youtube-form"
export default class extends Controller {
  static targets = [
    'youtubeUrlField',
    'resultArea',
    'youtubeIdField',
    'previewPlayer'
  ]

  connect() {
    this.refresh()
  }

  refresh() {
    const youtubeId = this.getYoutubeId(this.youtubeUrlFieldTarget.value)

    if (youtubeId) {
      this.youtubeIdFieldTarget.value = youtubeId
      this.resultAreaTarget.hidden = false
      this.previewPlayerTarget.src = `https://www.youtube.com/embed/${youtubeId}`
    } else {
      this.resultAreaTarget.hidden = true
      this.youtubeIdFieldTarget.value = ''
      this.previewPlayerTarget.src = ''
    }
  }

  getYoutubeId(url) {
    if (!url) return null

    const regex = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^?&#]+)/
    const match = url.match(regex)
    return match ? match[1] : null
  }
  // (例)
  // https://www.youtube.com/watch?v=abcdef123456
  // https://www.youtube.com/embed/abcdef123456
  // https://youtu.be/abcdef123456
  // https://www.youtube.com/watch?v=abcdef123456&t=30s
}
